import { type Metadata } from '../../entities/metadata';

// In-memory metadata state
let metadataState: Metadata = {
  domain: 'accure.net',
};

// Metadata state functions
export function getMetadata(): Metadata {
  return { ...metadataState };
}

export function updateMetadata(metadata: Partial<Metadata>): Metadata {
  metadataState = { ...metadataState, ...metadata };
  return { ...metadataState };
}
